import React, { useContext, useMemo } from "react";
import PropTypes from "prop-types";
import {
  Headline,
  SectionContent,
  List,
  Text,
  ContentWithImage,
} from "../common";
import { ModuleContext, PageContext } from "../../contexts";
import {
  ContentNavigation,
  NavigationLinkItemStyled,
  NavigationCardItemStyled,
  BodyLabelLink,
  CardIcon,
  Description,
  ListLinks,
} from "./NavigationLinks.style";

const NavigationLinks = ({
  sectionTitle,
  reverse,
  imgSrc,
  imgAlt,
  image,
  imgColumnSize,
}) => {
  const { pages, moduleUrl } = useContext(ModuleContext);
  const { path: currentPage, parentPage } = useContext(PageContext);

  const othersPages = useMemo(() => {
    const parentPagePath = `${moduleUrl}${parentPage}`;
    return pages.filter(
      ({ path, disableNavigation }) =>
        !disableNavigation && currentPage !== path && parentPagePath !== path
    );
  }, [currentPage, moduleUrl, pages, parentPage]);

  return (
    <SectionContent>
      <Headline nivel="2" styleAs="3" text={sectionTitle} />
      <ContentNavigation
        as={ContentWithImage}
        imgColumnSize={imgColumnSize}
        reverse={reverse}
        imgSrc={imgSrc}
        imgAlt={imgAlt}
        image={image}
        hideMobile
      >
        <nav>
          <ListLinks
            as={List}
            listItems={othersPages}
            forEach={({ path, pageTitle, description }) => (
              <NavigationLinkItemStyled href={path} data-label={pageTitle}>
                <NavigationCardItemStyled>
                  <div>
                    <BodyLabelLink as={Text} bodyStrong text={pageTitle} />
                    <Description as={Text} text={description} textSize="sm" />
                  </div>
                  <CardIcon />
                </NavigationCardItemStyled>
              </NavigationLinkItemStyled>
            )}
          />
        </nav>
      </ContentNavigation>
    </SectionContent>
  );
};

NavigationLinks.defaultProps = {
  sectionTitle: "Comece por aqui",
  reverse: true,
  imgSrc: null,
  imgAlt: "Ilustração do Produto",
  image: null,
  imgColumnSize: 6,
};

NavigationLinks.propTypes = {
  sectionTitle: PropTypes.string,
  reverse: PropTypes.bool,
  imgSrc: PropTypes.string,
  imgAlt: PropTypes.string,
  imgColumnSize: PropTypes.number,
  image: (props, propName, componentName) => {
    const { imgSrc, [propName]: imageValue } = props;
    if (!imgSrc && !imageValue) {
      return new Error(
        `Invalid prop ${propName} supplied to ${componentName}. Validation failed.`
      );
    }
    return null;
  },
};

export default NavigationLinks;
